import { ADMIN_USER_LEVEL } from '@/shared/common/constants/userLevels.constant';
import { ADDITIONAL_ACCOUNTS_VIEW_USER_LEVELS } from '../constants/additionalAccountsAccess.constant';

/**
 * ML-5: la tabla de cuentas adicionales es visible para niveles 2, 3 y 4.
 * Vive acá y no dentro del módulo porque la decisión la toman dos consumidores
 * que no pueden importarse entre sí: el guard de la ruta
 * (`modules/additionalAccounts/router/`) y el ítem "Cuentas" del sidebar
 * (`shared/layouts/`). Si divergen, el menú y la ruta dejan de coincidir.
 */
export function canViewAdditionalAccountsManagement(userLevel: number): boolean {
  return ADDITIONAL_ACCOUNTS_VIEW_USER_LEVELS.includes(userLevel);
}

/**
 * ML-5: "Crear", "Editar" y "Eliminar" quedan restringidos a nivel 4. Un nivel
 * 2 o 3 entra a la página y ve la tabla, pero sin acciones de escritura.
 */
export function canManageAdditionalAccounts(userLevel: number): boolean {
  return userLevel === ADMIN_USER_LEVEL;
}
